import orderBy from 'lodash/orderBy'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { BookingTypeEnum } from '../models/property-details-page/booking-type-model'
import { getFiltersConfiguration } from '../redux/filters'
import { FilterSectionTransport } from '../transports/search-result-listing-static-transport'
import { FilterCollapsedState, FilterType } from '../components/app-components/filter-sort-section/types'

const MAX_POPULAR_FILTERS = 6

export const usePopularFilters = (filterSection: FilterSectionTransport) => {
    const filtersConfiguration = useSelector(getFiltersConfiguration)

    return useMemo(() => {
        const filterItems = (filtersConfiguration?.filters ?? [])
            .filter(
                filter =>
                    filter.type !== FilterType.PRICES &&
                    filter.type !== FilterType.CANCELLATION_POLICY &&
                    filter.type !== FilterType.POPULAR_FILTERS,
            )
            .flatMap(filter => filter.items ?? [])
            .filter(item => item?.title?.trim())

        const orderedFilterItems = orderBy(filterItems, ['views'], ['desc'])
        const popularFilters =
            orderedFilterItems.length >= MAX_POPULAR_FILTERS
                ? orderedFilterItems.slice(0, MAX_POPULAR_FILTERS)
                : orderedFilterItems

        const directBookingFilterItem = filtersConfiguration?.filters
            ?.find(item => item?.type === FilterType.BOOKING_TYPES)
            ?.items?.find(subItem => subItem?.value === BookingTypeEnum.DIRECT_BOOKING)

        const popularFiltersWithDirectBooking = directBookingFilterItem
            ? [directBookingFilterItem, ...popularFilters]
            : popularFilters

        const popularFiltersTitle = filterSection?.popularFilters || ''

        return {
            type: FilterType.POPULAR_FILTERS,
            items: popularFiltersWithDirectBooking,
            itemsActive: '',
            title: popularFiltersTitle,
            multiple: true,
            moreOrEqual: false,
            isHorizontal: false,
            collapsedState: FilterCollapsedState.UNFOLD,
        }
    }, [filtersConfiguration?.filters, filterSection])
}
